import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { CATEGORY_GROUPS } from "@/data/catalog";

function Row({ label, hint, checked, onToggle, testId }) {
  return (
    <label className="flex cursor-pointer items-center gap-3 py-1.5 text-sm text-slate-700">
      <Checkbox checked={checked} onCheckedChange={onToggle} data-testid={testId} />
      <span className="flex-1">{label}</span>
      {hint != null && <span className="text-xs text-slate-400">{hint}</span>}
    </label>
  );
}

export default function FilterPanel({
  selectedCategories,
  selectedBrands,
  selectedTypes,
  selectedRefrigerants,
  facets,
  categoryCounts = {},
  onToggleCategory,
  onToggleBrand,
  onToggleType,
  onToggleRefrigerant,
  onClear,
}) {
  return (
    <div data-testid="filter-panel" className="overflow-hidden rounded-lg border border-slate-200 bg-white">
      <div className="flex items-center justify-between border-b border-slate-200 bg-slate-50 px-5 py-3.5">
        <h2 className="font-heading text-sm font-bold uppercase tracking-[0.15em] text-slate-900">Refine</h2>
        <Button variant="ghost" size="sm" className="h-auto p-0 font-mono text-xs text-sky-700 hover:bg-transparent hover:text-sky-800" onClick={onClear} data-testid="clear-filters-button">
          Clear all
        </Button>
      </div>
      <div className="p-5">

      {CATEGORY_GROUPS.map((group) => {
        const cats = group.categories.filter((c) => !c.hidden);
        return (
          <div key={group.label} className="mb-4">
            <h3 className="mb-1 text-xs font-semibold uppercase tracking-widest text-slate-500">{group.label}</h3>
            {cats.map((c) => (
              <Row
                key={c.slug}
                label={c.name}
                hint={categoryCounts[c.slug] || 0}
                checked={selectedCategories.includes(c.slug)}
                onToggle={() => onToggleCategory(c.slug)}
                testId={`filter-category-${c.slug}`}
              />
            ))}
          </div>
        );
      })}

      {facets.brands.length > 0 && (
        <>
          <Separator className="my-4" />
          <div>
            <h3 className="mb-1 text-xs font-semibold uppercase tracking-widest text-slate-500">Brand</h3>
            {facets.brands.map((b) => (
              <Row key={b.slug} label={b.name} checked={selectedBrands.includes(b.slug)} onToggle={() => onToggleBrand(b.slug)} testId={`filter-brand-${b.slug}`} />
            ))}
          </div>
        </>
      )}

      {facets.types.length > 0 && (
        <>
          <Separator className="my-4" />
          <div>
            <h3 className="mb-1 text-xs font-semibold uppercase tracking-widest text-slate-500">Product Type</h3>
            {facets.types.map((t) => (
              <Row key={t} label={t} checked={selectedTypes.includes(t)} onToggle={() => onToggleType(t)} testId={`filter-type-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} />
            ))}
          </div>
        </>
      )}

      {facets.refrigerants.length > 0 && (
        <>
          <Separator className="my-4" />
          <div>
            <h3 className="mb-1 text-xs font-semibold uppercase tracking-widest text-slate-500">Refrigerant</h3>
            {facets.refrigerants.map((r) => (
              <Row key={r} label={r} checked={selectedRefrigerants.includes(r)} onToggle={() => onToggleRefrigerant(r)} testId={`filter-refrigerant-${r.toLowerCase()}`} />
            ))}
          </div>
        </>
      )}
      </div>
    </div>
  );
}
